import { useEffect } from 'react';
import '../sections/ServiceDetails.css';
import '../sections/Services.css';
import './ServiceDetailLayout.css';
import { getServiceBySlug } from '../data/servicesData';
import Process from '../sections/Process';
import CTA from '../sections/CTA';
import { svcIcons } from '../sections/Services';

const IconCheck = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

export default function ServiceDetailLayout({ slug }) {
  const d = getServiceBySlug(slug);

  useEffect(() => {
    if (d) document.title = `${d.title} | AerialRoot Services`;
  }, [d]);

  if (!d) {
    return (
      <>
        <div className="page-top-spacer" />
        <div className="sd-notfound reveal">
          <h2 className="section-title">Service Not Found</h2>
          <p className="section-sub">That service page doesn't exist.</p>
          <a href="#/services" className="btn-ghost">← Back to All Services</a>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="page-top-spacer" />

      {/* Hero */}
      <section className="sdp-hero">
        <div className="sdp-hero-text reveal-left">
          <a href="#/services" className="sdp-breadcrumb">← All Services</a>
          <span className="svc-panel-icon">{svcIcons[d.icon]}</span>
          <span className="section-label">Our Service</span>
          <h1 className="sdp-title">{d.title}</h1>
          <p className="sdp-tagline">{d.tagline}</p>
          <p className="sdp-desc">{d.desc}</p>
          {d.stats && (
            <div className="svc-stats-row">
              {d.stats.map(st => (
                <div key={st.label} className="svc-stat-pill">
                  <span className="svc-stat-value">{st.value}</span>
                  <span className="svc-stat-label">{st.label}</span>
                </div>
              ))}
            </div>
          )}
          <div className="sdp-hero-actions">
            <a href="#/contact" className="btn-white">Get a Free Quote →</a>
          </div>
        </div>
        <div className="sdp-hero-img reveal-right">
          <img src={d.img} alt={d.title} />
        </div>
      </section>

      {/* Details (features + benefits), reusing sd-* classes */}
      <section className="sd-section">
        <div className="sd-row">
          <div className="sd-content reveal-left">
            <h3 className="sd-title">What's Included</h3>
            <p className="sd-intro">{d.intro}</p>

            <h4 className="sd-subhead">Key Features</h4>
            <ul className="sd-list">
              {d.features.map(f => (
                <li key={f}><span className="sd-check"><IconCheck /></span>{f}</li>
              ))}
            </ul>

            <h4 className="sd-subhead">Business Benefits</h4>
            <ul className="sd-list">
              {d.benefits.map(b => (
                <li key={b}><span className="sd-check"><IconCheck /></span>{b}</li>
              ))}
            </ul>
          </div>
          <div className="sd-img reveal-right">
            <img src={d.img} alt={d.title} loading="lazy" />
          </div>
        </div>
      </section>

      <Process />

      <CTA />
    </>
  );
}
